
import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {PartnerPersonModel} from '../../../api/entity/partnerPerson.model';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';

@Injectable({
    providedIn: 'root'
})
export class PartnerPersonRepository extends AbstractRepositoryV2<PartnerPersonModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PartnerPerson', serviceElementsFactory, injector);
    }
}
